import './App.css';
import { Route, Routes } from 'react-router-dom'
import LiveTv from './tv/LiveTv/LiveTv';
import { init } from '@noriginmedia/norigin-spatial-navigation';
import Preview from './tv/homePage/components/Preview';
import PiPage from './tv/homePage/components/PiPage';
import Login from './tv/login/login';
import SearchPage from './tv/homePage/search/searchPage';
import Epg from './tv/homePage/epg/epg';
import RemoveDevicePreview from './tv/homePage/components/removeDevice';
import PlanPage from './tv/homePage/components/planPage';
import PlanPageWeb from './tv/homePage/components/planPageWeb';
import TrailerPage from './tv/homePage/components/TrailerPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { SpinnerRoundFilled } from 'spinners-react';
import DialogBox from './DialogBox';
import ChooseProfilePage from './tv/profile/chooseProfilePage/ChooseProfilePage';
import ProfileEditPage from './tv/profile/profileEditPage/ProfileEditPage';
import ProfileLock from './tv/profile/profileLockPage/ProfileLock';
import Settings from './tv/Settings';
import TVPlayerMain from './TvPlayer/TvPlayer';
import { DISPLAYPLATFORM } from './constant';
import SearchPageWeb from './tv/homePage/search/searchPageWeb';
import LoginWeb from './tv/login/loginWeb';
import SignupWeb from './tv/signup/SignupWeb';

function App() {

  init({
    throttleKeypresses: true,
    throttle: 100
  });

  const { applicationLoading, applicationError } = useSelector((state) => state.application);

  if (applicationLoading) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "black" }}>
        <SpinnerRoundFilled size={120} thickness={100} speed={100} color="white" />
      </div>
    );
  }

  if (applicationError) {
    return (
      <div style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "black" }}>
        <h1 style={{ color: "white" }}>Error: {applicationError}</h1>
        <p style={{ color: "white" }}>Please try again later.</p>
      </div>
    );
  }

  return <>
    <ToastContainer />
    <DialogBox />
    <Routes>
      <Route path='/' element={<Preview displayPlatform={DISPLAYPLATFORM.WEB} />} />
      <Route path='/mobile' element={<Preview displayPlatform={DISPLAYPLATFORM.MOBILE} />} />
      <Route path='/tv' element={<Preview displayPlatform={DISPLAYPLATFORM.TV} />} />

      {/* Login */}
      <Route path='/login' element={<Login />} />
      <Route path='/loginWeb' element={<LoginWeb />} />

      {/* Signup */}
      <Route path='/signupWeb' element={<SignupWeb />} />

      <Route path='/search' element={<SearchPageWeb />} />
      <Route path='/tv/search' element={<SearchPage />} />
      <Route path='/liveTv' element={<LiveTv />} />
      <Route path='/epg' element={<Epg />} />
      <Route path='/removeDevice' element={<RemoveDevicePreview />} />
      <Route path='/plans' element={<PlanPage />} />
      <Route path='/plansweb' element={<PlanPageWeb />} />
      <Route path='/trailers' element={<TrailerPage />} />

      <Route path='/:title' element={<Preview displayPlatform={DISPLAYPLATFORM.WEB} />} />
      <Route path='/mobile/:title' element={<PiPage />} />
      <Route path='/tv/:title' element={<PiPage />} />

      <Route path='/profile' element={<ChooseProfilePage />} />
      <Route path='/profile/new' element={<ProfileEditPage />} />
      <Route path='/profile/new/profileLock' element={<ProfileEditPage />} />
      <Route path='/profile/edit' element={<ProfileEditPage />} />
      <Route path='/profile/edit/profileLock' element={<ProfileLock />} />
      <Route path='/profileLock' element={<ProfileLock />} />
      <Route path='/Settings' element={<Settings />} />
      <Route path='/TvPlayer' element={<TVPlayerMain />} />
    </Routes>
  </>
}

export default App;


